<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (form) {
    <form class="astral-content-width astral-content-width--with-list-surface astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-l">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <app-autocomplete-remote-paged
            [control]="form.controls['rentalObjectId']"
            [service]="rentalObjectService"
          ></app-autocomplete-remote-paged>
          <astral-input [control]="form.controls['key']"></astral-input>
          <astral-input [control]="form.controls['caption']"></astral-input>
          <app-autocomplete-remote-paged
            [control]="form.controls['keyTypeId']"
            [service]="keyTypeService"
            [defaultSearch]="'*'"
          ></app-autocomplete-remote-paged>
          <astral-input [control]="form.controls['systemNumber']"></astral-input>
          <astral-input [control]="form.controls['supplier']"></astral-input>
          <astral-input [control]="form.controls['marking']"></astral-input>
          <astral-input [integerOnly]="true" [control]="form.controls['quantity']"></astral-input>
          <astral-input [integerOnly]="true" [control]="form.controls['quantityLentOut']"></astral-input>
          <astral-input [integerOnly]="true" [control]="form.controls['quantityInStorage']"></astral-input>
        </astral-layout-group>
      </section>
      @if (!isNew) {
        <section class="astral-section-surface astral-section-surface--list-width astral-stack-l">
          <h5>{{ 'RENTALOBJECT_KEY.HANDOVER_DIRECTION' | translate }}</h5>
          <app-list-view
            [columnDefinition]="handoversColumnDefinition"
            [itemsSource]="dataContext.handovers"
            [preferencesKey]="'rent.rental-object-key.handovers'"
            (rowClick)="onHandoverRowClicked($event)"
          ></app-list-view>
          <div class="astral-form-actions astral-form-actions--start">
            <astral-button
              variant="primary"
              size="small"
              type="button"
              labelKey="RENTALOBJECT_KEY.HANDOUT_NO_SIGNATURE"
              (click)="handoutKeys()"
            ></astral-button>
            <astral-button
              variant="secondary"
              size="small"
              type="button"
              labelKey="RENTALOBJECT_KEY.RETURN_NO_SIGNATURE"
              (click)="returnKeys()"
            ></astral-button>
          </div>
        </section>
      }
    </form>
  }
</section>

<ng-template #sidebarContent>
  @if (handoverContext) {
    <app-rental-object-key-handover-form
      [dataContext]="handoverContext"
      (cancelOperation)="closeSidebar()"
      (deleteOperation)="sidebarDeleted()"
      (formSubmitted)="sidebarSubmitted()"
      >
    </app-rental-object-key-handover-form>
  }
</ng-template>
